@if (filter(); as filter) {
  <div class="flex flex-col gap-5">
    <div class="flex items-center">
      <div class="flex flex-col flex-1">
        <h3 class="text-on-surface dark:text-on-surface-darkmode font-semibold">
          {{ 'cockpit.energyInterfaces.details.consumption.sectionTitle' | transloco }}
        </h3>
        <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
          {{ 'cockpit.energyInterfaces.details.consumption.sectionSubtitle' | transloco }}
        </p>
      </div>
      <div class="flex-none flex gap-3 items-center">
        <ui-button mode="outlined" [routerLink]="['../load-curve']" *hasRole="'USER_ADMIN'">
          <ng-icon name="heroCloudArrowUp" size="20" slot="start" class="!block" />
          {{ 'cockpit.energyInterfaces.details.consumption.uploadLoadCurveButton' | transloco }}
        </ui-button>

        <ui-switch-bar
          [formField]="form.view"
          class="w-full sm:w-[116px] inline-block"
          (valueChange)="onChangeView($event)"
        >
          <ui-switch-bar-option value="line">
            <ng-icon name="heroArrowTrendingUp" size="20" class="!block" />
          </ui-switch-bar-option>
          <ui-switch-bar-option value="bar">
            <ng-icon name="heroChartBar" size="20" class="!block" />
          </ui-switch-bar-option>
          <ui-switch-bar-option value="table">
            <ng-icon name="heroListBullet" size="20" class="!block" />
          </ui-switch-bar-option>
        </ui-switch-bar>
      </div>
    </div>

    <app-analysis-consumption-graph-card
      [filter]="filter"
      [state]="data()"
      [organizationId]="organizationId()"
      (changeDate)="onChangeDate($event)"
      (changeGranularity)="onChangeGranularity($event)"
      (clickReload)="onClickReload()"
    />

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <app-analysis-consumption-details-kpi-card [filter]="filter" [state]="data()" />
      <app-analysis-consumption-details-peakload-kpi-card [filter]="filter" [state]="data()" />
    </div>
  </div>
}
